<div class="comment-section" *appLoader="(loadingActions | actionInProgress | async) === true">
  <div class="comment-text-area position-relative">
    <app-ui-text-area
      class="ui-form-field--no-hint-row"
      [control]="control"
      [class.disabled]="privilege | checkPermission"
      [label]="(comment ? 'editComment' : 'comment') | translate"
      [placeholder]="'commentPlaceholder' | translate"
      #commentTextarea
    ></app-ui-text-area>
    @if (control.value?.length) {
      <div class="comment-text-area-counter">{{ control.value?.length || 0 }} / 1000</div>
    }
    <button class="hidden-trigger" #menuTrigger [matMenuTriggerFor]="menu"></button>
    <div class="comment-actions">
      <div class="comment-actions-left">
        <app-ui-button
          class="m-0"
          (click)="addMention()"
          tooltip="{{ 'mentionSomeone' | translate }}"
          buttonType="icon-button"
          iconVariant="legacy"
          icon="alternate_email"
          [privilege]="privilege"
        ></app-ui-button>
        <app-ui-button
          class="m-0"
          (click)="attachmentsComponent.openAddDialog()"
          tooltip="{{ 'addAttachment' | translate }}"
          buttonType="icon-button"
          iconVariant="legacy"
          icon="upload"
          [privilege]="privilege"
        ></app-ui-button>
      </div>
      <div class="comment-actions-right">
        @if (comment) {
          <app-ui-button
            class="m-0"
            [text]="'cancel' | translate"
            buttonType="secondary"
            (click)="cancelEdit()"
          ></app-ui-button>
        }
        <app-ui-button
          class="m-0"
          [text]="(comment ? 'update' : 'send') | translate"
          buttonType="secondary"
          (click)="comment ? updateComment() : addComment()"
          [privilege]="privilege"
          [disabled]="control.invalid"
        ></app-ui-button>
      </div>
    </div>
  </div>
  <div class="attachments-list">
    @for (attachment of attachmentsControl.value || []; track attachment.id || $index) {
      <div class="attachment-item">
        <div class="attachment-name" (click)="attachmentsComponent.openEditDialog(attachment)">
          {{ attachment.name }}
        </div>
        <app-ui-button
          class="m-0 small-icon"
          (click)="attachmentsComponent.delete(attachment)"
          buttonType="icon-button"
          iconVariant="legacy"
          icon="close"
        ></app-ui-button>
      </div>
    }
  </div>
  <app-ui-attachments
    #attachmentsComponent
    viewMode="embedded"
    addButtonIcon="add"
    addButtonText="{{ 'addAttachment' | translate }}"
    [attachments]="attachmentsControl"
    [editMode]="true"
    [passiveMode]="false"
  ></app-ui-attachments>
  <mat-menu
    #menu="matMenu"
    overlayPanelClass="user-mention-menu-backdrop"
    class="user-mention-menu"
    [class.cdk-visually-hidden]="!searchUsersResults().length"
  >
    <div class="user-search-results">
      @for (user of searchUsersResults(); track user.id) {
        <div class="user-search-item" (click)="selectUser(user)">
          <div class="user-name">{{ user.fullName }}</div>
          <div class="user-email">{{ user.email }}</div>
        </div>
      }
    </div>
  </mat-menu>
</div>
